export default __webpack_public_path__ + "static/media/10k-unachieved.5d942897.svg";